import React from 'react';
import { Button } from 'antd';
import 'antd/dist/antd.css';
import { Link, RouteComponentProps, useRouteMatch } from 'react-router-dom';
import { FaUserEdit, FaUserLock, FaUserMinus } from 'react-icons/fa';
import { useAppSelector } from 'app/config/store';
// eslint-disable-next-line @typescript-eslint/no-empty-interface
// export interface IOptionsProps {}

export const SurveillantOptions = (props: RouteComponentProps<{ id: string; ecoleid: string }>) => {
  const { url } = useRouteMatch();
  const { match } = props;
  const id = props.match.params.id;
  const ecoleId = props.match.params.ecoleid;
  return (
    <div>
      <h4 className="pt-4">Options</h4>
      <Button style={{ backgroundColor: '#ffc107', color: 'black', borderRadius: 16 }}>
        <Link to="/account/reset/request" id="jh-create-entity" data-cy="entityCreateButton">
          <FaUserLock title="delete" />
          &nbsp; Réinitialiser mot de passe
        </Link>
      </Button>
      <Button type="primary" style={{ marginTop: 5, borderRadius: 16 }}>
        <Link to={`/surveillant/${ecoleId}/${id}/edit`} id="jh-create-entity" data-cy="entityCreateButton">
          <FaUserEdit title="editer" />
          &nbsp; Modifier
        </Link>
      </Button>
      <Button style={{ marginTop: 5, backgroundColor: '#dc3545', color: 'white', borderRadius: 16 }}>
        <Link to={`/surveillant/${ecoleId}/${id}/delete`} id="jh-create-entity" data-cy="entityCreateButton">
          <FaUserMinus title="delete" />
          &nbsp; Supprimer
        </Link>
      </Button>
    </div>
  );
};

export default SurveillantOptions;
